import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

export const BUYER_CORE_FIELDS = `
  id
  status
  name
  companyName
  displayName
  fullDisplayName
  street
  city
  state
  postalCode { formatted, value}
  phoneNumber { formatted, value}
  email
  notes
  reviewedBy { id, fullName }
  reviewedAt
  reviewNotes
  defaultTitleReleaseInviteAt
  defaultTitleReleaseAt
  titleOwnerName
  titleShippingAddress1
  titleShippingAddress2
  titleCity
  titleState
  titleZip
  titleShipOwnerName
  titleShipShippingAddress1
  titleShipShippingAddress2
  titleShipCity
  titleShipState
  titleShipZip
  defaultTitleReleaseSignature
`;

const BUYER_FIELDS = `
  ${BUYER_CORE_FIELDS}
  registeredAt
  buyerUsers(scopes: ["visible"]) {
    id
    firstName
    lastName
    email
    paddleNumber
    role
    invitationSentAt
    invitationAcceptedAt
  }
  files {
    id
    name
    fileUrl
  }
`;

const BUYER_VARIABLES = `
  $name: String
  $companyName: String
  $street: String
  $city: String
  $state: String
  $postalCode: String
  $phoneNumber: String
  $email: String
  $status: String
  $notes: String
  $reviewNotes: String
`;

const BUYER_ARGUMENTS = `
  name: $name
  companyName: $companyName
  street: $street
  city: $city
  state: $state
  postalCode: $postalCode
  phoneNumber: $phoneNumber
  email: $email
  status: $status
  notes: $notes
  reviewNotes: $reviewNotes
`;

const BUYER_FIELDS_AND_ERRORS = `
  buyer {
    ${BUYER_CORE_FIELDS}
  }
  ${ERRORS}
`;

export const BUYERS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    buyersWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${BUYER_CORE_FIELDS}
        registeredAt
      }
      count
      pendingReviewCount
    }
  }
`;

export const BUYERS = gql`
  query Buyers($scopes: [String!]) {
    buyers(scopes: $scopes) {
      ${BUYER_CORE_FIELDS}
    }
  }
`;

export const CREATE_BUYER = gql`
  mutation CreateBuyer(
    ${BUYER_VARIABLES}
    $saleAssetId: ID
  ) {
    createBuyer(
      ${BUYER_ARGUMENTS}
      saleAssetId: $saleAssetId
    ) {
      ${BUYER_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_BUYER = gql`
  mutation UpdateBuyer(
    $id: ID!
    $saleAssetId: ID
    ${BUYER_VARIABLES}
  ) {
    updateBuyer(
      id: $id
      saleAssetId: $saleAssetId
      ${BUYER_ARGUMENTS}
    ) {
      ${BUYER_FIELDS_AND_ERRORS}
    }
  }
`;

export const BUYER = gql`
  query Buyer($id: ID!) {
    buyer(id: $id) {
      ${BUYER_FIELDS}
    }
  }
`;

export const MERGE_BUYER = gql`
  mutation MergeBuyer(
    $id: ID!
    $mergeIntoId: ID!
  ) {
    mergeBuyer(
      id: $id
      mergeIntoId: $mergeIntoId
    ) {
      errors {
        message
        path
      }
    }
  }
`;

export const HIDE_BUYER = gql`
  mutation HideBuyer($id: ID!) {
    hideBuyer(id: $id) {
      buyer {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_BUYER = gql`
  mutation UnhideBuyer($id: ID!) {
    unhideBuyer(id: $id) {
      buyer {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const SEND_DEFAULT_TITLE_RELEASE_INVITE = gql`
  mutation SendDefaultTitleReleaseInvite($id: ID!) {
    sendDefaultTitleReleaseInvite(id: $id) {
      buyer {
        id
        defaultTitleReleaseInviteAt
        defaultTitleReleaseAt
      }
      errors {
        path
        message
      }
    }
  }
`;
